"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierActions = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function IdentifierActions(_a) {
    var actions = _a.actions;
    var _b = (0, core_ui_1.usePopover)({
        excludeTarget: true,
    }), popoverRef = _b.popoverRef, isPopoverOpen = _b.isPopoverOpen, togglePopover = _b.togglePopover, targetRef = _b.targetRef;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, role: "button", tabIndex: -1, style: {
                marginLeft: 'auto',
                paddingLeft: 12,
            } },
            react_1.default.createElement(core_ui_1.IconButton, { type: "more", onClick: togglePopover, elementRef: targetRef, isActive: isPopoverOpen })),
        react_1.default.createElement(core_ui_1.Portal, { name: "identifier-actions-portal" },
            react_1.default.createElement(core_ui_1.Tether, { targetRef: targetRef, targetAnchor: "bottomRight", anchor: "topRight", yOffset: 10 },
                react_1.default.createElement(core_ui_1.PopoverAnimation, { isOpen: isPopoverOpen, direction: "up" },
                    react_1.default.createElement(core_ui_1.Box, { border: 1, borderRadius: 3, elementRef: popoverRef, boxShadow: "card", backgroundColor: "white" },
                        react_1.default.createElement(core_ui_1.Padding, { y: 8 },
                            react_1.default.createElement(core_ui_1.Menu2, { items: actions.map(function (action) { return (__assign(__assign({}, action), { onClick: function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (action.type === core_ui_1.MenuItemType.LINK && action.onClick) {
                                            action.onClick(e);
                                        }
                                    } })); }) }))))))));
}
exports.IdentifierActions = IdentifierActions;
